import { translate, useLocale } from "../localization";
import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { AppButton } from "../components/ui";

const UnauthorizedPage = () => {
  useLocale();
  return (
    <main
      style={{
        minHeight: "calc(100vh - 96px)",
        display: "grid",
        placeItems: "center",
        padding: "32px",
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          width: "100%",
          p: 4,
          borderRadius: 4,
          border: "1px solid",
          borderColor: "divider",
          textAlign: "center",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(244,248,250,0.98))",
          boxShadow: "var(--shadow-card-rest, 0 1px 2px rgba(0, 0, 0, 0.08))",
        }}
      >
        <LockOutlinedIcon
          sx={{
            fontSize: 42,
            color: "var(--color-action-primary, #239fc6)",
            mb: 1.5,
          }}
        />
        <Typography variant="h4" component="h1" gutterBottom>{translate("Access restricted")}</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>{translate("This section is not available for your current account permissions.")}</Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5, flexWrap: "wrap" }}>
          <AppButton component={Link} to="/" kind="secondary">{translate("Back to Home")}</AppButton>
          <AppButton component={Link} to="/account" kind="primary">{translate("View Account")}</AppButton>
        </Box>
      </Box>
    </main>
  );
};

export default UnauthorizedPage;
